import { ORGANISATIONS } from './constants';
import { FormConfig } from './types';

export const formConfig: Record<ORGANISATIONS, FormConfig> = {
  [ORGANISATIONS.COM_COM]: {
    country: 'newZealand',
    studyName: 'Measuring Broadband New Zealand',
    eulaLink: 'https://www.measuringbroadbandnewzealand.com/eula',
    faqsLink: 'https://www.measuringbroadbandnewzealand.com/faqs',
    showPostcodeField: true,
    showFibreAvailability: true,
    branding: {
      logo: '/img/signup-newzealand-logo.svg',
      reportsLink:
        'https://comcom.govt.nz/regulated-industries/telecommunications/monitoring-the-telecommunications-market/monitoring-new-zealands-broadband/Reports-from-Measuring-Broadband-New-Zealand',
      image: '/img/signup-newzealand.svg',
      colour: '#b10d29'
    }
  },
  [ORGANISATIONS.TRA]: {
    country: 'oman',
    studyName: 'Measuring Broadband Oman',
    eulaLink: 'https://www.measuringbroadbandoman.com/eula',
    faqsLink: 'https://www.measuringbroadbandoman.com/faqs',
    regionsLabel: 'SignupForm.governorate',
    regionsSelectPlaceholder: 'SignupForm.selectYourGovernorate',
    regions: {
      ar: [
        'مسقط',
        'الوسط',
        'مسند',
        'الداخلي',
        'شمال الشرقي',
        'جنوب الشرقي',
        'ظفا',
        'الظاهر',
        'البريم',
        'شمال الباطن',
        'جنوب الباطنة'
      ],
      en: [
        'Muscat',
        'Dofar',
        'Musandam',
        'Al Buraymi',
        'Ad Dakhliyah',
        'Al Batina North',
        'Al Batina South',
        'Ash Sharqiyah South',
        'Ash Sharqiyah North',
        'Adh Dhahirah',
        'Al Wusta'
      ]
    },
    cities: {
      ar: [
        'العامرا',
        'بوشر',
        'قريا',
        'الجاز',
        'محو',
        'الدق',
        'هيما',
        'خص',
        'مدحا',
        'بخ',
        'دب',
        'سماي',
        'نزو',
        'من',
        'إزك',
        'الحمرا',
        'بدب',
        'بهلا',
        'أد',
        'وادي بني خال',
        'صو',
        'القاب',
        'مصير',
        'الكامل والواف',
        'إبرا',
        'دما والطايي',
        'بدي',
        'المضيب',
        'جعلان بني بوحس',
        'جعلان بني بوعل',
        'صلال',
        'سد',
        'رخيو',
        'ضلكو',
        'طاق',
        'شليم وجزر الحلانيا',
        'مقش',
        'مربا',
        'ثمري',
        'ضن',
        'عبر',
        'البريم',
        'ينق',
        'محض',
        'صح',
        'الرستا',
        'شنا',
        'نخ',
        'وادي المعاو',
        'لو',
        'الخابور',
        'بركا',
        'العواب',
        'السوي',
        'المصنع',
        'مسق',
        'السي',
        'مطر',
        'صحا',
        'الجبل الأخض',
        'سنا',
        'السنين',
        'المزيونة'
      ],
      en: [
        'AL AMRAT',
        'BAWSHAR',
        'QURAYYAT',
        'AL JAZIR',
        'MAHAWT',
        'AD DUQM',
        'HAYMA',
        'KHASAB',
        'MADHA',
        'BUKHA',
        'DABA',
        'SAMAIL',
        'NIZWA',
        'MANAH',
        'IZKI',
        'AL HAMRA',
        'BIDBID',
        'BAHLA',
        'ADAM',
        'WADI BANI KHALID',
        'SUR',
        'AL QABIL',
        'MASIRAH',
        'AL KAMIL WA AL WAFI',
        'IBRA',
        'DAMA WA AT TAIYIN',
        'BIDIYAH',
        'AL MUDAYBI',
        'JAALAN BANI BU HASAN',
        'JAALAN BANI BU ALI',
        'SALALAH',
        'SADAH',
        'RAKHYUT',
        'DALKUT',
        'TAQAH',
        'SHALIM',
        'MUQSHIN',
        'MIRBAT',
        'THUMRAYT',
        'DANK',
        'IBRI',
        'AL BURAYMI',
        'YANQUL',
        'MAHADAH',
        'SAHAM',
        'AR RUSTAQ',
        'SHINAS',
        'NAKHAL',
        'WADI AL MAAWIL',
        'LIWA',
        'AL KHABURAH',
        'BARKA',
        'AL AWABI',
        'AS SUWAYQ',
        'AL MUSANAAH',
        'MUSCAT',
        'AS SEEB',
        'MUTRAH',
        'SOHAR',
        'Jabal Akhdar',
        'Sinaw',
        'Al Sinina',
        'Al Mazyona'
      ]
    },
    showPhoneNumberField: true,
    branding: {
      logo: '/img/signup-oman-logo.svg',
      image: '/img/signup-oman.svg',
      colour: '#1967fb'
    }
  },
  [ORGANISATIONS.INTERNAL_TESTING]: {
    studyName: 'Measuring Broadband Test Name',
    eulaLink: 'https://sktesting.com/eula',
    faqsLink: 'https://sktesting.com/faqs',
    regionsLabel: 'SignupForm.governorate',
    regionsSelectPlaceholder: 'SignupForm.selectYourGovernorate',
    regions: {
      ar: ['Region 1 ar', 'Region 2 ar', 'Region 3 ar'],
      en: ['Region 1 en', 'Region 2 en', 'Region 3 en'],
      fr: ['Region 1 fr', 'Region 2 fr', 'City 3 fr']
    },
    cities: {
      ar: ['City 1 ar', 'City 2 ar', 'City 3 ar'],
      en: ['City 1 en', 'City 2 en', 'City 3 en'],
      fr: ['City 1 fr', 'City 2 fr', 'City 3 fr']
    },
    showPhoneNumberField: true,
    showPostcodeField: true,
    showFibreAvailability: true,
    branding: {
      image: '/img/login.svg'
    }
  }
};
